module.exports = __webpack_public_path__ + "img/a_konov.4dfe158f.jpg";